// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610160805/js/" + chunkId + "." + {"44":"cacf3a0b","225":"c6149aef","481":"cb7e60de","486":"70096483","770":"120077e9"}[chunkId] + ".0.15473649813066404.chunk.js";
};